export const COLOR_RED = "#e01b24";
export const COLOR_BLUE = "#3584e4";
export const COLOR_GREEN = "#33d17a";
export const COLOR_PURPLE = "#9141ac";
export const COLOR_ORANGE = "#ff7800";
export const COLOR_YELLOW = "#f6d32d";
export const COLOR_BROWN = "#986a44";
export const COLOR_LIGHT_RED = "#f88d81";
export const COLOR_LIGHT_BLUE = "#a8caf3";
export const COLOR_LIGHT_GREEN = "#a0f2b2";
export const COLOR_LIGHT_PURPLE = "#e19ce2";
export const COLOR_LIGHT_ORANGE = "#ffc885";
